import React from 'react';

import Divider from '../Divider';
import FooterWrapper from './FooterWrapper';
import StyledModalMobile from './StyledModalMobile';

export type BaseModalProps = React.PropsWithChildren<{
  isOpen: boolean;
  onClose: () => void;
  footer: React.ReactNode;
  title: string;
}>;

const BaseModal: React.FC<BaseModalProps> = ({
  children,
  isOpen,
  onClose,
  footer,
  title,
  ...rest
}) => {
  return (
    <StyledModalMobile
      isOpen={isOpen}
      onClose={onClose}
      onBackdropClick={onClose}
      title={title}
      footer={<FooterWrapper>{footer}</FooterWrapper>}
      {...rest}
      style={{ overflowX: 'hidden' }}
    >
      <Divider />
      {children}
    </StyledModalMobile>
  );
};

export default BaseModal;
